import React from 'react'
import styled from 'styled-components'
import { Modal, Carousel } from 'react-bootstrap'
import guide1 from '../../images/event/quiz-01.jpg'
import guide2 from '../../images/event/quiz-02.jpg'
import guide3 from '../../images/event/quiz-03.jpg'
import guide4 from '../../images/event/quiz-04.jpg'
import guide5 from '../../images/event/quiz-05.jpg'
import guide6 from '../../images/event/quiz-06.jpg'
import guide7 from '../../images/event/quiz-07.jpg'
import guide8 from '../../images/event/quiz-08.jpg'
import guide9 from '../../images/event/quiz-09.jpg'

const StyledModal = styled(Modal)`
  .modal-content {
    /* background: transparent; */
    border: none;
    border-radius: 0px;
  }
  .modal-header {
    border: none;
    
    .close {
      color: #000;
      opacity: 0.5;
      padding: 0 16px;
      font-size: 40px;
      font-weight: 400;
      text-shadow: none;
    }
  }
  .modal-body {
    padding: 0 36px;
    padding-bottom: 36px;
  }
  .carousel-control-next, 
  .carousel-control-prev {
    opacity: 0.5;
    filter: invert(0.3);
  }
  .carousel-control-prev {
    left: -10%;
  } 
  .carousel-control-next {
    right: -10%;
  }
`

export default function InstructionModal({ showModal, hideSchedule }) {
  const slides = [guide1, guide2, guide3, guide4, guide5, guide8, guide9, guide6, guide7 ]
  
  return (
    <StyledModal show={showModal} onHide={hideSchedule} aria-labelledby="images-modal" centered size={"lg"} > 
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <Carousel>
          {slides.map((poster,index)=>(
            <Carousel.Item key={`poster-${index}`} interval={4000}>
              <img className="d-block" src={poster} alt={`poster-${index}`} width="100%" />
            </Carousel.Item>
          ))}
        </Carousel>
      </Modal.Body>
    </StyledModal>
  )
}
